export const enumToText = (enumValue: string | undefined) => {
    if (!enumValue) {
        return '';
    }

    let text = '';
    const splited = enumValue.split('_');

    splited.forEach((value: string) => {
        text += `${value.charAt(0)}${value.toLowerCase().substring(1, value.length)} `;
    });

    return text;
};
